import CoachingConstants from 'coaching/CoachingConstants';
import TutoringSelfServeViewSummary from 'coaching/components/TutoringSelfServeView/TutoringSelfServeViewSummary';
import TutoringSelfServeViewBilling from 'coaching/components/TutoringSelfServeView/TutoringSelfServeViewBilling/TutoringSelfServeViewBilling';
import {
  RestoredGetStartedAuthenticated,
  RestoredGetStartedUnauthenticated,
  RestoredLinkStudent,
  RestoredSchedule,
  RestoredStudentDetailsUnauthenticated,
} from 'coaching/components/TutoringSelfServeView/TutoringStorageViews';
import { State } from 'lib/TutoringStateMachine/StateMachine';

export enum STATES {
  GET_STARTED_AUTH = 'get_started_authenticated',
  GET_STARTED_UNAUTH = 'get_started_unauthenticated',
  STUDENT_DETAILS_UNAUTH = 'student_details_unauthenticated',
  SCHEDULE = 'schedule',
  BILLING = 'billing',
  LINK_STUDENT = 'link_student',
  SUMMARY = 'summary',
}

export const stateConfig: {
  [k in STATES]: State;
} = {
  [STATES.GET_STARTED_UNAUTH]: {
    name: STATES.GET_STARTED_UNAUTH,
    location: CoachingConstants.TUTORING_GET_STARTED,
    component: RestoredGetStartedUnauthenticated,
  },
  [STATES.GET_STARTED_AUTH]: {
    name: STATES.GET_STARTED_AUTH,
    location: CoachingConstants.TUTORING_GET_STARTED,
    component: RestoredGetStartedAuthenticated,
  },
  [STATES.STUDENT_DETAILS_UNAUTH]: {
    name: STATES.STUDENT_DETAILS_UNAUTH,
    location: CoachingConstants.TUTORING_STUDENT_DETAILS,
    component: RestoredStudentDetailsUnauthenticated,
  },
  [STATES.LINK_STUDENT]: {
    name: STATES.LINK_STUDENT,
    location: CoachingConstants.TUTORING_LINK_STUDENT,
    component: RestoredLinkStudent,
  },
  [STATES.SUMMARY]: {
    name: STATES.SUMMARY,
    location: CoachingConstants.TUTORING_SUMMARY,
    component: TutoringSelfServeViewSummary,
  },
  [STATES.SCHEDULE]: {
    name: STATES.SCHEDULE,
    location: CoachingConstants.TUTORING_SCHEDULE,
    component: RestoredSchedule,
  },
  [STATES.BILLING]: {
    name: STATES.BILLING,
    location: CoachingConstants.TUTORING_BILLING,
    component: TutoringSelfServeViewBilling,
  },
} as const;
